export const getVisibility = state => state.isVisible;
export const getContent = state => state.content;
export const getStatus = state => state.status;

export default {
  getVisibility,
  getContent,
  getStatus
};



// WEBPACK FOOTER //
// ./src/store/modules/prompt/getters.js